"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterSeparator = void 0;

var _ = require(".");

var _jsxRuntime = require("react/jsx-runtime");

var FooterSeparator = function FooterSeparator(_ref) {
  var order = _ref.order;
  return (0, _jsxRuntime.jsx)(_.Box, {
    height: {
      _: '2px',
      lg: '220px'
    },
    width: {
      _: '150px',
      lg: '2px'
    },
    mx: {
      _: 0,
      lg: '55px'
    },
    my: {
      _: '20px',
      lg: 0
    },
    backgroundColor: "footer.separator",
    opacity: 0.2,
    order: order
  });
};

exports.FooterSeparator = FooterSeparator;